import { DefaultModal, ModalType } from '@frontend/components/kiosk';
import { Module } from '@frontend/module/types';
import { LuX } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

export interface ChooseModuleModalProps {
    modules: Module[] | null;
    show: boolean;
    onClose: () => void;
    onSelectModule: (module: Module) => void;
    currentModule?: Module | null;
}

export const ChooseModuleModal = (props: ChooseModuleModalProps) => {
    if (!props.show) return null;

    const handleSelectModule = (module: Module) => {
        props.onSelectModule(module);
        props.onClose();
    };

    return (
        <DefaultModal
            show={props.show}
            handleClose={props.onClose}
            type={ModalType.PROMPT}
            className='m-4 w-full overflow-hidden'>
            <div className='bg-background-surface border-border-default flex flex-col gap-6 overflow-hidden rounded-2xl border p-6'>
                <div className='flex h-6 w-full shrink-0 items-start justify-between self-stretch'>
                    <span className='text-foreground-default text-xl font-semibold'>
                        <FormattedMessage
                            id='kiosk.choose-module.title'
                            defaultMessage='Choose a module'
                            description='Title for the choose-module modal'
                        />
                    </span>
                    <button
                        type='button'
                        className='relative size-6 cursor-pointer overflow-hidden border-0 bg-transparent p-0'
                        onClick={props.onClose}
                        aria-label='Close'>
                        <LuX className='text-foreground-default size-6' />
                    </button>
                </div>

                <div className='text-foreground-default flex w-full flex-col gap-4 font-medium'>
                    <div className='flex w-full flex-col gap-2'>
                        <div className='inline-flex flex-wrap content-start items-start justify-start gap-2 self-stretch'>
                            {props.modules?.map((module) => {
                                const isSelected = props.currentModule?.id === module.id;
                                const chipClass = isSelected
                                    ? 'bg-brand-light border-brand-secondary text-brand-secondary border'
                                    : 'bg-background-surface border-border-default text-foreground-default border';

                                return (
                                    <button
                                        type='button'
                                        key={module.id}
                                        onClick={() => handleSelectModule(module)}
                                        className={`inline-flex h-9 min-w-9 items-center justify-center gap-2.5 rounded-lg px-3 ${chipClass}`}>
                                        <span className='text-sm font-semibold'>{module.index}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </DefaultModal>
    );
};
